// Libs
import { createSlice } from '@reduxjs/toolkit';
import { createCoupon, deleteCoupon, getDetailCoupon, getListCoupon, updateCoupon } from './couponThunk';
import { RootState } from '~/utils/redux/store';

// Others

export interface ICouponState {
  isLoading: boolean;
  isRefreshCouponList: boolean;
}

export const initialState: ICouponState = {
  isLoading: false,
  isRefreshCouponList: false,
};

const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    setRefreshCouponList(state, action) {
      state.isRefreshCouponList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list coupon
    builder
      .addCase(getListCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListCoupon.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getListCoupon.rejected, (state) => {
        state.isLoading = false;
      });

    // GET: Create Coupon
    builder
      .addCase(createCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCoupon.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshCouponList = true;
      })
      .addCase(createCoupon.rejected, (state) => {
        state.isLoading = false;
      });

    // GET: Get Detail Coupon
    builder
      .addCase(getDetailCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailCoupon.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getDetailCoupon.rejected, (state) => {
        state.isLoading = false;
      });

    // GET: Update Coupon
    builder
      .addCase(updateCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCoupon.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshCouponList = true;
      })
      .addCase(updateCoupon.rejected, (state) => {
        state.isLoading = false;
      });

    // GET: Delete Coupon
    builder
      .addCase(deleteCoupon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCoupon.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshCouponList = true;
      })
      .addCase(deleteCoupon.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// Action
export const couponActions = couponSlice.actions;

// Selectors
export const selectIsRefreshListCoupon = (state: RootState) => state.coupon.isRefreshCouponList;
// Reducer
const couponReducer = couponSlice.reducer;
export default couponReducer;
